import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * EditorialCard — a flexible card used for articles and news.
 * Props: number, overline (category), title, excerpt, image, meta (date · read), href
 */
const EditorialCard = ({
  number,
  overline,
  title,
  excerpt,
  image,
  meta,
  href,
  imageAspect = "aspect-[4/3]",
  testId,
}) => {
  return (
    <motion.article
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="editorial-card p-5 md:p-6 h-full flex flex-col group"
      data-testid={testId || "editorial-card"}
    >
      <Link to={href} className="block flex-1 flex flex-col" data-testid={`${testId || "editorial-card"}-link`}>
        {image && (
          <div className={`relative overflow-hidden ${imageAspect} mb-6 bg-cream`}>
            <img
              src={image}
              alt=""
              loading="lazy"
              className="card-image absolute inset-0 w-full h-full object-cover"
            />
            {number && (
              <div className="absolute top-3 left-3 number-shadow text-4xl md:text-5xl leading-none select-none opacity-90">
                {number}
              </div>
            )}
          </div>
        )}
        {overline && <div className="overline overline-muted mb-3">{overline}</div>}
        <h3 className="font-display text-ink text-2xl md:text-[26px] leading-[1.15] font-normal group-hover:text-gold-dark transition-colors">
          {title}
        </h3>
        {excerpt && (
          <p className="mt-3 text-ink-soft text-sm md:text-[15px] leading-relaxed line-clamp-3">{excerpt}</p>
        )}
        <div className="mt-auto pt-6 flex items-center justify-between border-t border-ink-line">
          <div className="text-[11px] font-mono-editorial uppercase tracking-[0.18em] text-ink-muted">{meta}</div>
          <span className="inline-flex items-center gap-1 text-ink text-xs font-medium">
            Read <ArrowUpRight size={14} />
          </span>
        </div>
      </Link>
    </motion.article>
  );
};

export default EditorialCard;
